export default __webpack_public_path__ + "static/media/menu-close.361f7ba5.svg";